"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snackBarStore = void 0;
const zustand_1 = require("zustand");
exports.snackBarStore = zustand_1.default((set) => ({
    message: '',
    open: false,
    setOpen: (open) => set((state) => (Object.assign(Object.assign({}, state), { open }))),
    setmessage: (message) => set((state) => (Object.assign(Object.assign({}, state), { message: message }))),
}));
//# sourceMappingURL=SnackbarStore.js.map